import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { styled } from "@mui/material/styles"
import { Link } from "react-router-dom"

export const StyledLink = styled(Link)({
  display: "flex",
  alignItems: "center",
  padding: "4px 0",
  textDecoration: "none"
})

export const StyledFontAwesomeIcon = styled(FontAwesomeIcon)(({ theme }) => ({
  marginLeft: "8px",
  color: theme.palette.secondary.main
}))
